const NOTIFICATION_START = '<!-- NOTIFICATION -->';
const NOTIFICATION_END = '<!-- /NOTIFICATION -->';

export interface ReleaseInfo {
  version: string;
  releaseDate: string;
  notificationMessage: string;
  fullMarkdown: string;
}

interface VersionConfig {
  version: string;
  releaseDate: string;
}

export function parseReleaseMarkdown(content: string): {
  notificationMessage: string;
  fullMarkdown: string;
} | null {
  const startIdx = content.indexOf(NOTIFICATION_START);
  const endIdx = content.indexOf(NOTIFICATION_END);

  if (startIdx === -1 || endIdx === -1) {
    return null;
  }

  const notificationMessage = content
    .substring(startIdx + NOTIFICATION_START.length, endIdx)
    .trim();

  if (!notificationMessage) {
    return null;
  }

  // Remove notification markers from the full markdown
  const fullMarkdown = content
    .substring(endIdx + NOTIFICATION_END.length)
    .trim();

  return { notificationMessage, fullMarkdown };
}

export async function fetchReleaseInfo(): Promise<ReleaseInfo | null> {
  try {
    const versionResponse = await fetch('/version.json');
    if (!versionResponse.ok) {
      console.warn('[ReleaseNotification] version.json not found');
      return null;
    }

    const versionConfig: VersionConfig = await versionResponse.json();
    const { version, releaseDate } = versionConfig;

    if (!version || version === 'latest') {
      return null;
    }

    const mdResponse = await fetch(`/releases/${version}.md`);
    if (!mdResponse.ok) {
      console.warn(
        `[ReleaseNotification] No release notes found for ${version}`
      );
      return null;
    }

    const content = await mdResponse.text();
    const parsed = parseReleaseMarkdown(content);

    if (!parsed) {
      console.warn(
        `[ReleaseNotification] No NOTIFICATION section in ${version}.md`
      );
      return null;
    }

    return {
      version,
      releaseDate,
      notificationMessage: parsed.notificationMessage,
      fullMarkdown: parsed.fullMarkdown,
    };
  } catch (error) {
    console.warn('[ReleaseNotification] Failed to load release info:', error);
    return null;
  }
}
